import React from 'react';

import { useResponsiveScreenSizes } from 'hooks/useResponsiveScreenSizes';

import { ChevronLarge } from 'components/svg/ChevronLarge';

import { Fonts, colors, SVGComponent } from 'styles/theme';
import {
    ItemContentWrapper,
    ItemIconWrapper,
    MenuItemWrapper,
} from 'styles/menuItem';

export interface MenuItemProps {
    isSelected: boolean;
    SVGComponent?: SVGComponent;
    imageUrl?: string;
    text: string;
}

export const MenuItem = ({
    isSelected,
    SVGComponent,
    imageUrl,
    text,
}: MenuItemProps) => {
    const { isMobileScreenSize } = useResponsiveScreenSizes();
    return (
        <MenuItemWrapper $isSelected={isSelected}>
            <ItemContentWrapper>
                <ItemIconWrapper
                    $isSelected={isSelected}
                    $isImageAsset={imageUrl != null && imageUrl !== ''}
                >
                    {SVGComponent == null ? null : (
                        <SVGComponent
                            color={
                                isSelected
                                    ? colors.mountainAsh
                                    : colors.darkJungle
                            }
                        />
                    )}

                    {imageUrl == null || imageUrl === '' ? null : (
                        <img
                            src={imageUrl}
                            width={20}
                            height={20}
                            alt="menu-icon"
                        />
                    )}
                </ItemIconWrapper>
                {isMobileScreenSize ? (
                    <Fonts.XSmall
                        $color={
                            isSelected ? colors.mountainAsh : colors.darkJungle
                        }
                    >
                        {text}
                    </Fonts.XSmall>
                ) : (
                    <Fonts.Small
                        $color={
                            isSelected ? colors.mountainAsh : colors.darkJungle
                        }
                    >
                        {text}
                    </Fonts.Small>
                )}
            </ItemContentWrapper>
            {isMobileScreenSize ? null : (
                <ChevronLarge
                    color={isSelected ? colors.mountainAsh : colors.darkJungle}
                />
            )}
        </MenuItemWrapper>
    );
};
